<!--
Deadline component
Usage: <Deadline title="text" body="text" icon="fa-name" link="url" />
@author ab557z
-->
<template>
  <div id="contain" class="container">
    <Nav name="Assessment Details" :back='true' :home='true' />
    <Spinner ref="spinner" />
     <div class="courseName">
          <ExpandText
            :content="course.name"
            :limit=30
            styleoverride="font-size:24px;"
            />
        </div>
    <table class="subAssessmentHeader">
      <tr>
        <td>
          <img class="subAssessmentImg" src="@/assets/af/individual_components.svg">
        </td>
        <td v-if="loading" class="header-message">
            Please wait for the individual components to load ...
        </td>
        <td v-if="!loading" class="header-message">
            This assessment comprises {{ singPlural(subAssessments.length, ' sub-assessment', ' sub-assessments') }}.<br/>
            Below are details of each sub-assessment.
        </td>
      </tr>
    </table>
    <div class="detailBody">
        <div v-for="(sub, index) in subAssessments" v-bind:key="sub.id" >
          <Deadline
            isSubAssessment="true"
            v-if="inDeadlinesTab (sub)" v-bind:key="sub.ID"
           :deadline="sub" :id="'order_by_' + index" />
           <Grade
            isSubAssessment="true"
            v-else v-bind:key="sub.ID"
            :deadline="sub" :id="'order_by_' + index" />
        </div>
    </div>
    <br/>
    <Footer active="notifications" />
  </div>
</template>

<script>
import axios from 'axios'
import StringUtil from '@/mixins/StringUtil.js'
import AssFeedCommon from '@/mixins/AssFeedCommon.js'
import IDBCommon from '@/mixins/IDBCommon.js'
import Deadline from '@/components/af/Deadline.vue'
import Grade from '@/components/af/Grade.vue'
import Footer from '@/components/FooterMenu.vue'
import ExpandText from '@/components/ExpandableText.vue'

export default {
  name: 'AssessmentDetails',
  props: ['id'],
  components: {
    Footer,
    Deadline,
    Grade,
    ExpandText
  },
  data () {
    return {
      loading: true,
      subAssessments: [ ],
      course: {
        name: '',
        url: ''
      }
    }
  },
  mixins: [StringUtil, AssFeedCommon, IDBCommon],
  // el: '.dlDates'

  mounted () {
    if (this.idbSupported()) {
      this.tryAssessmentLoadFromIdb(this.id)
    } else {
      this.getAssessmentDetails(this.id)
    }
  },
  methods: {
    async tryAssessmentLoadFromIdb (subId) {
      const guid = this.$cookies.get('guid')
      let gi = await this.getGuidInfo(guid)
      if (typeof gi !== 'undefined' && 'grades-components' in gi) {
        const deadlines = gi['grades-components']
        console.log('individual component data for ' + Object.keys(deadlines))
        if (subId in deadlines) {
          this.subAssessments = deadlines[subId]
          this.loading = false
          console.log('fetched sub assessment data internally')
        } else {
          console.log('*** assessment data is there but not for id ' + subId)
          this.getAssessmentDetails(subId)
        }
        this.processAssessments()
      } else {
        this.getAssessmentDetails(subId)
      }
    },
    getAssessmentDetails (subId) {
      this.$refs.spinner.spin()
      axios.get('/timetable/grades/subassessments?subId=' + subId)
        .then(response => {
          this.subAssessments = response.data

          this.processAssessments()
        }).finally(() => {
          this.loading = false
          this.$refs.spinner.stop()
        })
    },
    processAssessments () {
      // sort in ascending date order BUT ALSO put deadlines up top
      this.subAssessments.sort((a, b) => {
        const acat = (this.isGraded(a.gradehasgrade) ? 2 : 1) // 1 = deadline, 2 = grade
        const bcat = (this.isGraded(b.gradehasgrade) ? 2 : 1)
        if (acat > bcat) return 1
        if (bcat > acat) return -1
        return a.duedate - b.duedate
      })
      // pick up the course name and url for the heading
      this.subAssessments.map(sa => {
        this.course.name = sa.coursename
        this.course.url = sa.courseurl
      })
    },
    dispDate (dteSecs) {
      const dte = new Date(dteSecs)
      const d = this.objectForDate(dte)
      return d['display']
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/common-styles.scss';
  .header-message {
    font-size: 14px;
    margin-top: 10px;
    text-align: center;
    color: var(--uog-dark-blue);
  }

  .detailBody {
    margin-bottom: 40px;
  }
  .course {
    font-weight: 700;
  }
  .assmtTitle {
    font-size: 20px;
    font-weight: 700;
  }
  .assmtDetails {
    padding-top:4px;
    font-size: 18px;
    font-weight: 400;
  }
  .sa-section {
    margin-left:24px;
    margin-right:24px;
  }
  table.subAssessmentHeader tr td {
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left:12px;
    text-align: left;
}
  .subAssessmentImg {
    margin-left:20px;
  }
</style>
